import React, { useState, useEffect, useMemo } from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import CardDropdown from 'components/common/CardDropdown';
import { Link } from 'react-router-dom';
import IconItem from 'components/common/icon/IconItem';
import IconButton from 'components/common/IconButton';
import axios from 'helpers/api';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import { Badge, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';

const MedHourTable = (props) => {
    const [drugunit, setDrugUnit] = useState([]);
    const [statusFilter, setStatusFilter] = useState('active');

    function handleEditInput(editValue) {
        props.onCallEditParent(editValue);
    }

    const columns = useMemo(() => [
        {
            accessorKey: 'unit',
            header: 'Drug Unit',
            meta: {
                headerProps: { className: 'pe-1 col-lg-6 text-start text-900' }
            }
        },
        {
            accessorKey: 'is_active',
            header: 'Status',
            meta: {
                headerProps: { className: 'text-900 text-center' },
                cellProps: { className: 'text-center' }
            },
            cell: ({ row: { original } }) => {
                const isActive = original.is_active == 1 || original.is_active === '1' || original.is_active === true;
                return (
                    <Badge bg={isActive ? 'success' : 'secondary'}>
                        {isActive ? 'Active' : 'Inactive'}
                    </Badge>
                );
            }
        },
        {
            accessorKey: 'Action',
            header: 'Action',
            meta: {
                headerProps: { className: 'text-900 text-center', style: { width: '100px' } },
                cellProps: { className: 'text-center align-middle', style: { width: '100px' } }
            },
            enableSorting: false,
            cell: ({ row: { original } }) => {
                return (
                    <div className="d-flex justify-content-center align-items-center">
                        <IconItem
                            tag="button"
                            icon={['far', 'edit']}
                            size="sm"
                            onClick={() => handleEditInput({
                                unit: original.unit,
                                unit_name: original.unit,
                                is_active: original.is_active,
                                unit_id: original.unit_id,
                                drug_unit_id: original.unit_id,
                                id: original.unit_id
                            })}
                            className="btn rounded-3 fs-11 align-items-center"
                        />
                    </div>
                );
            }
        }
    ], []);

    useEffect(() => {
        async function fetchMedHourDetails() {
            let tokenStr = localStorage.getItem("accessToken");
            try {
                let res;
                try {
                    res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/drugs/get-drug-unit/`, {
                        headers: { 'Authorization': `Bearer ${tokenStr}` }
                    });
                } catch {
                    console.log("Error fetching Med Hour details");
                }

                if (res?.data?.status && res?.data?.data) {
                    const results = res.data.data.map(value => ({
                        unit: value.unit,
                        unit_id: value.id,
                        is_active: value.is_active
                    }));
                    setDrugUnit(results);
                } else {
                    setDrugUnit([]);
                }
            } catch (err) {
                toast.info("No Drug Units found in this list");
                setDrugUnit([]);
            }
        }

        fetchMedHourDetails();
    }, [props.trigger]);

    const filteredData = useMemo(() => {
        return drugunit.filter(item => {
            const isActive = item.is_active == 1 || item.is_active === '1' || item.is_active === true;
            if (statusFilter === 'active') return isActive;
            if (statusFilter === 'inactive') return !isActive;
            return true;
        });
    }, [drugunit, statusFilter]);

    const table = useAdvanceTable({
        data: filteredData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <div>
            <AdvanceTableProvider {...table}>
                <Row className="g-2 align-items-center mb-3">
                    <Col md={4}>
                        <AdvanceTableSearchBox placeholder="Search..." />
                    </Col>
                    <Col md={4} className="d-flex align-items-center gap-2">
                        <Form.Label className="mb-0 text-nowrap fw-semi-bold fs-10">Filter:</Form.Label>
                        <Form.Select
                            size="sm"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            style={{ minWidth: '150px' }}
                        >
                            <option value="active">Active Drug Unit</option>
                            <option value="inactive">Inactive Drug Unit</option>
                            <option value="all">All Drug Unit</option>
                        </Form.Select>
                    </Col>
                    <Col md={4} className="ms-auto d-flex justify-content-end">
                        <IconButton
                            variant="primary"
                            size="sm"
                            icon="plus"
                            transform="shrink-3 down-2"
                            onClick={props.onOpenAddModal}
                        >
                            Add Drug Unit
                        </IconButton>
                    </Col>
                </Row>
                {filteredData.length > 0 ? (
                    <AdvanceTable
                        headerClassName="bg-200 text-nowrap align-middle text-center"
                        rowClassName="text-nowrap align-middle"
                        tableProps={{
                            size: 'lg',
                            striped: true,
                            className: 'fs-10 mb-0'
                        }}
                    />
                ) : (
                    <div className="d-flex justify-content-center align-items-center text-center py-4">
                        <p className="text-danger fw-bold mb-0">There is no data available in the table</p>
                    </div>
                )}
                <div className="mt-3">
                    <AdvanceTableFooter
                        rowInfo
                        navButtons
                        rowsPerPageSelection
                    />
                </div>
            </AdvanceTableProvider>
        </div>
    );
};

export default MedHourTable;
